<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Edit Merk Barang</h5>
            </template>
            
            <b-form @submit.prevent="openModalConfirm">
                <div class="form-content-wrapper">
                    <h6 class="form-title">DATA UMUM</h6>
                    <b-form-group label="Merk Barang">
                        <b-form-input v-model="input.merkBarang" name="merkBarang" required></b-form-input>
                    </b-form-group>
                    <b-form-group label="Jenis Barang">
                        <multiselect name="jenisBarang"
                            :value="jenisBarang.find(item => item.id == input.jenisBarang) || null"
                            :options="jenisBarang" :internal-search="true" :allow-empty="false"
                            :disabled="true" deselect-label="" select-label="" label="name"
                            track-by="id" placeholder="Pilih Jenis Barang"
                            @input="input.jenisBarang = $event ? $event.id : null" />
                    </b-form-group>
                </div>

                <div class="form-content-wrapper">
                    <label>Surat Edaran Merk Barang</label>
                    <b-row>
                        <b-col sm="3">
                            
                                <FormulateForm v-model="pdf">
                                    <FormulateInput v-if="url.length != 0"
                                    id="urlPDF"
                                    name="urlPDF"
                                    ref="urlPDF"
                                    type="file"
                                    :value="url"
                                    help="Format Harus PDF"
                                    accept=".pdf"
                                    validation="mime:application/pdf"
                                    multiple
                                    />

                                    <FormulateInput v-else
                                    type="file"
                                    name="file"
                                    help="Format Harus PDF"
                                    validation="mime:application/pdf"
                                    accept=".pdf"
                                    fileRemove
                                    multiple
                                    />
               
                                </FormulateForm>

                        </b-col>
                        <b-col>
                            <div v-for="file of pdf.urlPDF.files">
                                <span v-if="url != null">
                                    <b-button size="sm" class="mb-3" variant="pgiBtn" @click="openModalPreviewPDF( file.base64 != null ?file.base64 : $baseFilePath + file.file.previewData )">View</b-button>
                                </span>
                            </div>
                           
                        </b-col>
                    </b-row>
                </div>

                <div class="form-content-wrapper">
                    <h6 class="form-title">SPESIFIKASI</h6>
                    <b-tabs class="tab-wrapper" content-class="tab-content-wrapper">
                        <b-tab title="Aktif">
                            <div>
                                <b-button variant="pgiBtn" class="mb-2" @click="addSpesifikasi" name="spesifikasiAddBtn"><i class="fa fa-plus mr-2"></i>Spesifikasi</b-button>
                               <Spesifikasi v-for="item in input.spesifikasi" v-bind:key="item.index"
                                    :spesifikasi="item" :length="input.spesifikasi.length" @remove="removeSpesifikasi(item.index, item.id)"
                                    @nonAktif="nonAktifSpesifikasi(item.index, item.id, item.detailInfo, item.name, item.nominalAngka, item.nominalPersen)"
                                    :idSpesifikasi="item.id" 
                                    :filePDF = "item.filePDF"
                                    @changeSESpek="changeSESpek"
                                    @openModalPreviewPDFSpekKel = "openModalPreviewPDFSpekKel"
                                    @removeSESpek = "removeSESpek"
                                /> 
                                    
                            </div>
                        </b-tab>
                        <b-tab title="Non Aktif">
                                <SpesifikasiNonAktif v-for="item in nonAktifSpesifikasiMerk" v-bind:key="item.index"
                                    :spesifikasi="item" :length="input.spesifikasi.length" @aktif="aktifSpesifikasi(item)"
                                />
                        </b-tab>
                    </b-tabs>
                </div>
                <!-- <div class="form-content-wrapper">
                    <h6 class="form-title">KONDISI</h6>
                    <label>Surat Edaran Kondisi Barang</label>
                    <b-row>
                        <b-col cols="10" md="3">
                         
                                <FormulateForm v-model="pdfKondisi">
                                    <FormulateInput v-if="urlKondisi.length != 0"
                                    ref="urlPDF"
                                    name="urlPDF"
                                    type="file"
                                    :value="urlKondisi"
                                    help="Format Harus PDF"
                                    accept=".pdf"
                                    validation="mime:application/pdf"
                                    multiple
                                    />

                                    <FormulateInput v-else
                                    type="file"
                                    name="file"
                                    help="Format Harus PDF"
                                    validation="mime:application/pdf"
                                    accept=".pdf"
                                    fileRemove
                                    multiple
                                    />
               
                                </FormulateForm>

                        </b-col>
                        <b-col cols="2">
                            <div v-for="file of pdfKondisi.urlPDF.files">
                                <span v-if="urlKondisi != null">
                                    <b-button size="sm" class="mb-3" variant="pgiBtn" @click="openModalPreviewPDF( file.file.size != null ?file.file : $baseFilePath + file.file.previewData )">View</b-button>
                                </span>
                            </div>
                        </b-col>
                    </b-row>
                    <b-tabs class="tab-wrapper" content-class="tab-content-wrapper">
                        <b-tab title="Aktif">
                            <div>
                                <b-button variant="pgiBtn" class="mb-2" @click="addKondisi" name="kondisiAddBtn"><i class="fa fa-plus mr-2"></i>Kondisi</b-button>
                                <Kondisi v-for="item in input.kondisi" v-bind:key="item.index"
                                    :kondisi="item" :length="input.kondisi.length" :isKendaraan="isKendaraan" @remove="removeKondisi(item.index, item.id)"
                                    @nonAktif="nonAktifKondisi(item)"
                                    :idKondisi="item.id" 
                                />
                            </div>
                        </b-tab>
                        <b-tab title="Non Aktif">
                            <KondisiNonAktif v-for="item in nonAktifKondisiMerk" v-bind:key="item.index"
                                :kondisi="item" :length="input.kondisi.length" :isKendaraan="isKendaraan"
                                @aktif="aktifKondisi(item)"
                            />
                        </b-tab>
                    </b-tabs>
                    
                </div> -->
                <div class="form-wrapper-btn submit-btn-wrapper">
                    <b-button type="submit" name="merkBarangUpdateBtn" variant="pgiBtn">Update</b-button>
                </div>
            </b-form>
        </b-card>
        <ModalConfirm id="modal-confirm-edit" title="Confirm Edit Merk Barang" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk mengubah merk barang ini?" @submit="onSubmit" />

        <ModalConfirm id="modal-confirm-hapus-spesifikasi" title="Confirm Hapus Spesifikasi"  desc="Apakah anda yakin untuk menghapus spesifikasi barang ini?" @submit="onSubmitHapusSpesifikasi" />
        
        <ModalConfirm id="modal-confirm-non-aktif-spesifikasi" title="Confirm Non Aktif Spesifikasi"  desc="Apakah anda yakin untuk menonaktifkan spesifikasi barang ini?" @submit="onSubmitNonAktifSpesifikasi" />
        <ModalConfirm id="modal-confirm-aktif-spesifikasi" title="Confirm Aktif Spesifikasi"  desc="Apakah anda yakin untuk mengaktifkan spesifikasi barang ini?" @submit="onSubmitAktifSpesifikasi" />

        <ModalConfirm id="modal-confirm-hapus-kondisi" title="Confirm Hapus Kondisi"  desc="Apakah anda yakin untuk menghapus kondisi barang ini?" @submit="onSubmitHapusKondisi" />
        <ModalConfirm id="modal-confirm-non-aktif-kondisi" title="Confirm Non Aktif Kondisi"  desc="Apakah anda yakin untuk menonaktifkan kondisi barang ini?" @submit="onSubmitNonAktifKondisi" />
        <ModalConfirm id="modal-confirm-aktif-kondisi" title="Confirm Aktif Kondisi"  desc="Apakah anda yakin untuk mengaktifkan kondisi barang ini?" @submit="onSubmitAktifKondisi" />
    
        <ModalConfirm  id="modal-hapus-se" title="Confirm Hapus SE" desc="SE Akan Terhapus Permanen" @submit=removeSE />
        <ModalConfirm  id="modal-hapus-se-spek" title="Confirm Hapus SE" desc="SE Akan Terhapus Permanen" @submit=confirmRemoveSESpek />
        <ModalConfirm  id="modal-hapus-se-kon" title="Confirm Hapus SE" desc="SE Akan Terhapus Permanen" @submit=removeSEKon />

         <!-- MODAL SHOW SE -->
         <b-modal id="modal-SE" size="lg" title="Modal SE">
                <iframe width="100%" height="700" allowfullscreen :src="activePdfPreview" frameborder="0"></iframe>
                <template v-slot:modal-footer="{ cancel }">
                    <b-button variant="secondary" name="closePreviewBtn" @click="cancel()">
                        Close
                    </b-button>
                </template>
        </b-modal>
    </div>
</template>

<script>
import Vue from 'vue'
import VueFormulate from '@braid/vue-formulate'

Vue.use(VueFormulate)
import Spesifikasi from '../../../components/spesifikasi/Spesifikasi'
import SpesifikasiNonAktif from '../../../components/spesifikasi/SpesifikasiNonAktif';
import Kondisi from '../../../components/kondisi/Kondisi'
import KondisiNonAktif from '../../../components/kondisi/KondisiNonAktif'

export default {
    name: 'edit-merk-barang',
    components: { 
        Spesifikasi, Kondisi, SpesifikasiNonAktif, KondisiNonAktif
    },
    data(){
        return{
            id: null,
            initStatus: 0,
            isSubmitting: false,
            input:{
                merkBarang: "",
                jenisBarang: null,
                spesifikasi: [],
                kondisi: [],
                filePDF: null,
                filePDFKondisi: null,
            },
            jenisBarang: [],
            indexSpesifikasi: 0,
            indexKondisi: 0,
            isKendaraan: false,
            deleteSpesifikasi: [],
            deleteKondisi: [],
            nonAktifSpesifikasiMerk: [],
            nonAktifKondisiMerk:[],
            modalConfirmRemove: {},
            modalConfirmNonAktif: {},
            modalConfirmAktif: {},

            pdf: {
                urlPDF : {
                    fileList:[]
                }
            },
            url : [],

            pdfKondisi: {
                urlPDF : {
                    fileList:[]
                }
            },
            urlKondisi : [],
            
            activePdfPreview:"",

            pdfRecords:[],
            pdfNewVal:[],
            hapusSE:[],

            idSpek:null,
            pdfRecordsSpek:[],
            pdfNewValSpek:[],

            idKon:null,
            pdfRecordsKon:[],
            pdfNewValKon:[],
        }
    },

    methods:{

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0
            this.id = this.$route.params.id

            let getJenis = this.$axios.get("barang-jenis/").then(response => {
                this.jenisBarang = response.data
            })

            let getSingleMerkBarang = this.$axios.get(`barang-merk/${this.id}`).then(response => {
                this.merkBarang = response.data

                if(this.merkBarang.suratEdaran.length != 0){
                   
                    for(var file of this.merkBarang.suratEdaran){
                        this.url.push({
                            id: file.id,
                            url:file.filepath,
                        })
                    }
                }

                // if(this.merkBarang.kondisi.suratEdaran.length != 0){
                //     for(var file of this.merkBarang.kondisi.suratEdaran){
                //         this.urlKondisi.push({
                //             id: file.id,
                //             url:file.filepath,
                //         })
                //     }
                // }
                //----------------- Inisialisasi Data Merk Barang -----------------

                this.input.merkBarang = this.merkBarang.name
                this.input.jenisBarang = this.merkBarang.barangJenis.id

                let nameSpec, detailInfoSpec, nominalPSpec, nominalASpec, nominalAngka = null
                for (var x of this.merkBarang.spesifikasi) {
                    nameSpec = x.name
                    let nominalPSpec, nominalASpec, nominalAngka = null

                    if (x.nominalAngka == null) {
                        detailInfoSpec = "persen",
                        nominalPSpec = x.nominalPersen                            
                    } 
                    else {
                        nominalAngka = this.$helper.addThousandSeparator(x.nominalAngka);
                        detailInfoSpec = "nominal",
                        nominalASpec = nominalAngka
                    }

                    if(x.isActive == true){
                        let url = []
                        for(var file of x.suratEdaran){
                                url.push({
                                id: file.id,
                                url:file.filepath,
                            })
                        }

                        this.input.spesifikasi.push({
                            index: this.indexSpesifikasi,
                            id: x.id,
                            name: nameSpec,
                            detailInfo: detailInfoSpec,
                            nominalPersen: nominalPSpec,
                            nominalAngka: nominalASpec,
                            filePDF: [],
                            url : url
                        })
                    }else if(x.isActive == false){
                        this.nonAktifSpesifikasiMerk.push({
                            index: this.indexSpesifikasi,
                            id: x.id,
                            name: nameSpec,
                            detailInfo: detailInfoSpec,
                            nominalPersen: nominalPSpec,
                            nominalAngka: nominalASpec
                        })
                    }
                    
                    this.indexSpesifikasi++
                }

             

                let nameMerk, ketMerk, namaSendiriMerk, dusMerk, detailInfoMerk, nominalPMerk, nominalAMerk, hargaMaksimalMerk= null

                for (var x of this.merkBarang.kondisi) {
                    nameMerk = x.name
                    ketMerk = x.keterangan
                    hargaMaksimalMerk = this.$helper.addThousandSeparator(x.hargaMaksimal)
                    let nominalPMerk, nominalAMerk, nominalAngka = null
                    

                    if (x.dus == null) {
                        if(x.namaSendiri == true) namaSendiriMerk = 0
                        else namaSendiriMerk = 1
                    } 
                    else {
                        if(x.dus == true) dusMerk = 0
                        else dusMerk = 1
                    }

                    if (x.nominalAngka == null) {
                        detailInfoMerk = "persen",
                        nominalPMerk = x.nominalPersen                            
                    } 
                    else {
                        nominalAngka = this.$helper.addThousandSeparator(x.nominalAngka);
                        detailInfoMerk = "nominal",
                        nominalAMerk = nominalAngka
                    }

                    if (dusMerk == null) dusMerk = 0
                    if (namaSendiriMerk == null) namaSendiriMerk = 0

                    if(x.isActive == true){

                        this.input.kondisi.push({
                            index: this.indexKondisi,
                            id: x.id,
                            name: nameMerk,
                            keterangan: ketMerk,
                            dus: dusMerk,
                            namaSendiri: namaSendiriMerk,
                            detailInfo: detailInfoMerk,
                            nominalPersen: nominalPMerk,
                            nominalAngka: nominalAMerk,
                            hargaMaksimal: hargaMaksimalMerk,
                            filePDF: [],
                        })
                    }else if(x.isActive == false){
                        this.nonAktifKondisiMerk.push({
                            index: this.indexKondisi,
                            id: x.id,
                            name: nameMerk,
                            keterangan: ketMerk,
                            dus: dusMerk,
                            namaSendiri: namaSendiriMerk,
                            detailInfo: detailInfoMerk,
                            nominalPersen: nominalPMerk,
                            nominalAngka: nominalAMerk,
                            hargaMaksimal: hargaMaksimalMerk
                        })
                    }
                    
                    this.indexKondisi++
                }    
              
            })


            let getKondisi = this.$axios.get("surat-edaran/list/?menu=kondisi"+this.$route.params.id+"&jenis=kondisi").then(response => {
              
            for(var file of response.data){
                    this.urlKondisi.push({
                        id: file.id,
                        url:file.filepath,
                    })
                }
            })

            Promise.all([getJenis, getSingleMerkBarang, getKondisi]).then(() => {
                let jenis = this.jenisBarang.filter(item => item.id == this.input.jenisBarang)
                let namaJenis = jenis[0].jenisPinjaman.name
                if (namaJenis == 'Kendaraan') {
                    this.isKendaraan = true
                } 
                else if (namaJenis == 'Elektronik') {
                    this.isKendaraan = false
                }
                this.initStatus = 1
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },

        //----------------- Fungsi Tambah Hapus Data Spesifikasi & Kondisi -----------------
        
        addSpesifikasi() {
            this.input.spesifikasi.unshift({ 
                index: this.indexSpesifikasi, 
                id: 0, 
                name: "", 
                detailInfo: "persen", 
                nominalPersen: null, 
                nominalAngka: null ,
                filePDF: [],
                url : []
            })
            this.indexSpesifikasi++;
        },

        removeSpesifikasi(index, id) {
            this.$bvModal.show("modal-confirm-hapus-spesifikasi")
            this.modalConfirmRemove = {
                index: index,
                id: id
            }
        },

        onSubmitHapusSpesifikasi() {
            this.$bvModal.hide("modal-confirm-hapus-spesifikasi")
            this.input.spesifikasi = this.input.spesifikasi.filter(item => item.index != this.modalConfirmRemove.index)
            if(this.modalConfirmRemove.id != 0){
                this.deleteSpesifikasi.push(this.modalConfirmRemove.id)
            }
        },

        //----------------- Fungsi aktif & non aktif Spesifikasi ------------------------

        nonAktifSpesifikasi(index, id, detailInfo, name, nominalAngka, nominalPersen) {
            this.$bvModal.show("modal-confirm-non-aktif-spesifikasi")
            this.modalConfirmNonAktif = {
                index: index,
                id: id,
                detailInfo: detailInfo,
                name: name,
                nominalAngka: nominalAngka,
                nominalPersen: nominalPersen
            }
        },

        onSubmitNonAktifSpesifikasi() {
            let payloadNonAktif = new FormData()
            payloadNonAktif.append("SpekId", this.modalConfirmNonAktif.id)
            payloadNonAktif.append("isActive", false)
            this.$axios.post("/barang-jenis/spesifikasi/switch-is-active", payloadNonAktif).then(response => {
                location.reload()
                // this.$helper.setFlash(`Merk barang telah berhasil di nonaktifkan!`)
                // let path = this.$route.path.split("/")
                // path.pop()
                // path = path.join("/")
                // this.$router.push({ path })
            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })

            this.$bvModal.hide("modal-confirm-non-aktif-spesifikasi")
        },

        aktifSpesifikasi(item) {
            this.$bvModal.show("modal-confirm-aktif-spesifikasi")
            this.modalConfirmAktif = item
        },

        onSubmitAktifSpesifikasi() {
            let payloadAktif = new FormData()
            payloadAktif.append("SpekId", this.modalConfirmAktif.id)
            payloadAktif.append("isActive", true)
                this.$axios.post("/barang-jenis/spesifikasi/switch-is-active", payloadAktif).then(response => {
                    location.reload()
                    // this.$helper.setFlash(`Merk barang telah berhasil di aktifkan!`)
                    // let path = this.$route.path.split("/")
                    // path.pop()
                    // path = path.join("/")
                    // this.$router.push({ path })
                })
                .catch(error => {
                    this.$helper.parseError(this, error)
                })
            // this.nonAktifSpesifikasiMerk = this.nonAktifSpesifikasiMerk.filter(item => item.index != this.modalConfirmAktif.index)
            // this.input.spesifikasi.push(this.modalConfirmAktif)
            this.$bvModal.hide("modal-confirm-aktif-spesifikasi")
        },

        //----------------- Fungsi tambah & hapus Kondisi ------------------------
        addKondisi() {
            this.input.kondisi.unshift({ 
                index: this.indexKondisi, 
                id: 0, 
                name: "", 
                dus: 0,
                namaSendiri: 0,
                keterangan: "",
                detailInfo: "persen",
                nominalPersen: null,
                nominalAngka: null,
                hargaMaksimal: 0,
                filePDF: [],
                url : []
            })
            this.indexKondisi++;
        },

        removeKondisi(index, id) {
            this.$bvModal.show("modal-confirm-hapus-kondisi")
            this.modalConfirmRemove = {
                index: index,
                id: id
            }
            // this.input.kondisi = this.input.kondisi.filter(item => item.index != index)
            // this.deleteKondisi.push(id)
        },

        onSubmitHapusKondisi() {
            this.$bvModal.hide("modal-confirm-hapus-kondisi")
            this.input.kondisi  = this.input.kondisi.filter(item => item.index != this.modalConfirmRemove.index)
            if(this.modalConfirmRemove.id != 0){
                this.deleteKondisi.push(this.modalConfirmRemove.id)
            }
            // this.deleteKondisi.push(this.modalConfirmRemove.id)
        },

        //----------------- Fungsi aktif & non aktif Kondisi ------------------------

        nonAktifKondisi(item) {
            this.$bvModal.show("modal-confirm-non-aktif-kondisi")
            this.modalConfirmNonAktif = item
        },

        onSubmitNonAktifKondisi() {
            let payloadNonAktif = new FormData()
            payloadNonAktif.append("id", this.modalConfirmNonAktif.id)
            payloadNonAktif.append("isActive", false)
            this.$axios.post("/barang-merk/kondisi/switch-is-active", payloadNonAktif).then(response => {
                location.reload()
                // this.$helper.setFlash(`Merk barang telah berhasil di nonaktifkan!`)
                // let path = this.$route.path.split("/")
                // path.pop()
                // path = path.join("/")
                // this.$router.push({ path })
            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            // this.input.kondisi = this.input.kondisi.filter(item => item.index != this.modalConfirmNonAktif.index)
            // this.nonAktifKondisiMerk.push(this.modalConfirmNonAktif)

            this.$bvModal.hide("modal-confirm-non-aktif-kondisi")
        },

        aktifKondisi(item) {
            this.$bvModal.show("modal-confirm-aktif-kondisi")
            this.modalConfirmAktif = item
        },

        onSubmitAktifKondisi() {
            let payloadAktif = new FormData()
            payloadAktif.append("id", this.modalConfirmAktif.id)
            payloadAktif.append("isActive", true)
                this.$axios.post("/barang-merk/kondisi/switch-is-active", payloadAktif).then(response => {
                    location.reload() 
                    // this.$helper.setFlash(`Merk barang telah berhasil di aktifkan!`)
                    // let path = this.$route.path.split("/")
                    // path.pop()
                    // path = path.join("/")
                    // this.$router.push({ path })
                })
                .catch(error => {
                    this.$helper.parseError(this, error)
                })
            // this.nonAktifKondisiMerk = this.nonAktifKondisiMerk.filter(item => item.index != this.modalConfirmAktif.index)
            // this.input.kondisi.push(this.modalConfirmAktif)
            this.$bvModal.hide("modal-confirm-aktif-kondisi")
        },

        //----------------- Fungsi Submit Data -----------------

        onSubmit(){
            var status = ""
            let payload = new FormData()

            //----------------- Append Data Jenis Barang -----------------


             //File PDF
            
             if( this.input.filePDF != null){
                for(var file of this.input.filePDF ){  
                    if(file.size != null){
                        //untuk struktur form file baru
                        payload.append("pdfFiles" , file)
                    }
                    else if (file.file.size != null){
                         //untuk struktur form file Lama
                        payload.append("pdfFiles" , file.file)
                    }else {
                        //Jika tidak Update Kirim File Kosong
                        let metadata = {
                            type: 'application/pdf'
                        }
                        let fileInput = new File([],"pdf",metadata)
                        payload.append("pdfFiles" , fileInput)
                    }
                }
            }

            // if(this.input.kondisi.length!=0 || this.input.kondisi !=null){
            //     for(var file of this.input.kondisi){
            //         payload.append("pdfKondisi" , "kondisi"+this.id)
            //     }
            // }

            // if( this.input.filePDFKondisi != null){

            //     let payloadKondisi = new FormData()
            //     payloadKondisi.append("menu" , "kondisi"+this.id)
            //     payloadKondisi.append("jenis" , "kondisi")
          
            //     for(var file of this.input.filePDFKondisi ){
                    
            //         if(file.size != null){
            //             //untuk struktur form file baru
                       
            //             payloadKondisi.append("pdfFiles" , file)
            //         }
            //         else if (file.file.size != null){
            //             //untuk struktur form file Lama
                                      
            //             payloadKondisi.append("pdfFiles" , file.file)       
            //         }
            //         else {
            //             //Jika tidak Update Kirim File Kosong
            //             let metadata = {
            //                 type: 'application/pdf'
            //             }
            //             let fileInput = new File([],"pdf",metadata)
            //             payloadKondisi.append("pdfFiles" , fileInput)
            //         }
            //     }

            //     this.$axios.post("surat-edaran/insertOrUpdate/",payloadKondisi).then(response => {
            //             })
            //             .catch(error => {
            //                 console.log(error)
            //                 console.log(error.response.data.reason)
            //                 this.$helper.parseError(this, error)
            //             })
            //             .finally(() => {
                            
            //             })
            //     }



            for (var x of this.input.spesifikasi) {
                let nominal = this.$helper.removeThousandSeparator(x.nominal);
                payload.append('spesifikasiId', x.id)
                payload.append('spesifikasiName', x.name)
                if (x.detailInfo == "nominal") {
                    let nominalAngka = this.$helper.removeThousandSeparator(x.nominalAngka);
                    payload.append('spesifikasiNominalAngka', nominalAngka)
                    payload.append('spesifikasiNominalPersen', null)
                } 
                else {
                    payload.append('spesifikasiNominalPersen', x.nominalPersen)
                    payload.append('spesifikasiNominalAngka', null)
                }

                //Append SE
                
                payload.append("pdfFilesSpesifikasi" , "spesifikasi"+x.id)
                    if(x.filePDF != null){
                        if( x.filePDF.length != 0){

                            let payloadSpesifikasi = new FormData()
                            payloadSpesifikasi.append("menu" , "spesifikasi"+x.id)
                            payloadSpesifikasi.append("jenis" , "spesifikasi")
                           
                            for(var file of x.filePDF){
        
                            if(file.size != null){
                                payloadSpesifikasi.append("pdfFiles", file)   
                            }
                            else if(file.file.url == null){
                                payloadSpesifikasi.append("pdfFiles", file.file)                 
                            }
                            else {
                                //Jika tidak Update Kirim File Kosong
                                let metadata = {
                                    type: 'application/pdf'
                                }
                                let fileInput = new File([],"pdf",metadata)
                                payloadSpesifikasi.append("pdfFiles" , fileInput)
                                }
                            }
                        
                            this.$axios.post("surat-edaran/insertOrUpdate/",payloadSpesifikasi).then(response => {
                            })
                            .catch(error => {
                                console.log(error)
                                console.log(error.response.data.reason)
                                this.$helper.parseError(this, error)
                            })
                        }
                       
                    }

            }

            // for (var x of this.input.kondisi) {
            //     payload.append('kondisiId', x.id)
            //     payload.append('kondisiName', x.name)
            //     const nominalHargaMaks = this.$helper.removeThousandSeparator(x.hargaMaksimal);
            //     payload.append('kondisiHargaMaksimal', nominalHargaMaks)

            //     if (this.isKendaraan == false) {
            //         if (x.dus == 0) {
            //             status = true
            //         } 
            //         else {
            //             status = false
            //         }
            //         payload.append('kondisiDus', status)
            //     } 
            //     else {
            //         if (x.namaSendiri == 0) {
            //             status = true
            //         } 
            //         else {
            //             status = false
            //         }
            //         payload.append('kondisiNamaSendiri', status)
            //     }

            //     payload.append('kondisiKeterangan', x.keterangan)

            //     if (x.detailInfo == "nominal") {
            //         let nominalAngka = this.$helper.removeThousandSeparator(x.nominalAngka);
            //         payload.append('kondisiNominalAngka', nominalAngka)
            //         payload.append('kondisiNominalPersen', null)
            //     } 
            //     else {
            //         payload.append('kondisiNominalPersen', x.nominalPersen)
            //         payload.append('kondisiNominalAngka', null)
            //     }
            // }

            if (this.deleteSpesifikasi != []) {
                for(var x of this.deleteSpesifikasi){
                    payload.append("deleteSpesifikasiId", x)
                }
            }

            if (this.deleteKondisi != []) {
                for (var x of this.deleteKondisi) {
                    payload.append("deleteKondisiId", x)
                }
            }

            payload.append("id", this.id)
            payload.append("name", this.input.merkBarang)
            payload.append("jenisBarangId", this.input.jenisBarang)


            //Hapus se jika ada
            if(this.hapusSE.length != 0){
                for(var id of this.hapusSE){
                        let payloadHapus = new FormData()
                        payloadHapus.append("id", id)
                        this.$axios.post("surat-edaran/delete/", payloadHapus)
                }    
            }

            //----------------- Submit Semua Data -----------------

            this.isSubmitting = true
            
            this.$axios.post("barang-merk/", payload).then(response => {
                this.$helper.setFlash(`Merk barang telah berhasil diubah!`)
                let path = this.$route.path.split("/")
                path.pop()
                path = path.join("/")
                this.$router.push({ path })
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
        },


        //----------------- Fungsi Lain -----------------

        openModalConfirm(){
            // if (this.input.kondisi.length == 0) {
            //     this.$helper.toastErr(this, "Tolong masukkan minimal 1 kondisi")
            //     return
            // } 

            if(this.input.filePDF != null){

           if(this.input.filePDF != null){
            for(var file of this.input.filePDF){
                
                    if(file.type != null){
                            if(file.type != "application/pdf" ){
                            this.$helper.toastErr(this, 'file '+file.name+' bukan PDF')
                            return
                        }
                    }else{
                            if(file.file.type != "application/pdf"){
                            this.$helper.toastErr(this, 'file '+file.name+' bukan PDF')
                            return
                        }
                    } 
                }
            }
        }

            for( var spesifikasi of this.input.spesifikasi){
               
                if(spesifikasi.filePDF != null){
                    for(var file of spesifikasi.filePDF){
                      
                       if(file.type != null){
                            if(file.type != "application/pdf" ){
                            this.$helper.toastErr(this, 'file '+file.name+' bukan PDF')
                            return
                        }
                        }else{
                            if(file.file.type != "application/pdf"){
                            this.$helper.toastErr(this, 'file '+file.name+' bukan PDF')
                            return
                        }
                    } 
                  
                }
                }
                
            }

            //    for( var kondisi of this.input.kondisi){
         
            //     if(kondisi.filePDF != null){
            //         for(var file of kondisi.filePDF){
                    
            //            if(file.type != null){
            //                 if(file.type != "application/pdf" ){
            //                 this.$helper.toastErr(this, 'file '+file.name+' bukan PDF')
            //                 return
            //             }
            //             }else{
            //                 if(file.file.type != "application/pdf"){
            //                 this.$helper.toastErr(this, 'file '+file.name+' bukan PDF')
            //                 return
            //             }
            //         } 
                  
            //     }
            //     }
                
            // }

             this.$bvModal.show("modal-confirm-edit")
        },

        openModalPreviewPDF(pdf){
     
            this.activePdfPreview = pdf
           
            this.$bvModal.show("modal-SE")
        },

          //----------------- Fungsi SE Spesifikasi -----------------
          changeSESpek(idSpesifikasi,filePDF){
          
            let idx = this.input.spesifikasi.findIndex(item => item.id == idSpesifikasi)
            this.input.spesifikasi[idx].filePDF = filePDF
       
        },

        openModalPreviewPDFSpekKel(base64){
            this.activePdfPreview = base64
            this.$bvModal.show("modal-SE")
        },

        removeSE(){
       
            for(var file of this.pdf.urlPDF.files){
               let idx = this.pdfNewVal.findIndex(item => item.name == file.name)
               if(idx == -1){
                if(file.path.id != undefined){
                    this.hapusSE.push(file.path.id)
                }
               }
            }

            this.pdf.urlPDF.files = this.pdfNewVal
            this.pdfRecords = this.pdfNewVal
            this.$bvModal.hide("modal-hapus-se")
        },
        removeSEKon(){
     
            for(var file of this.pdfKondisi.urlPDF.files){

               let idx = this.pdfNewValKon.findIndex(item => item.name == file.name)
               if(idx == -1){
                if(file.path.id != undefined){
                    this.hapusSE.push(file.path.id)
                }
               }
            }

            this.pdfKondisi.urlPDF.files = this.pdfNewValKon
            this.pdfRecordsKon = this.pdfNewValKon
            this.$bvModal.hide("modal-hapus-se-kon")
        },

        removeSESpek(idSpek,pdfRecords,newVal){
            this.idSpek = idSpek
            this.pdfRecordsSpek = pdfRecords
            this.pdfNewValSpek = newVal

            this.$bvModal.show("modal-hapus-se-spek")
        },
        confirmRemoveSESpek(){
      
            let spek = this.input.spesifikasi
            let idx = spek.findIndex(item => item.id == this.idSpek)

            for(var file of  spek[idx].filePDF){
               
                let idxNewVAl = this.pdfNewValSpek.findIndex(item => item.name == file.name)
                if(idxNewVAl == -1){
                    if(file.path.id != undefined){
                        this.hapusSE.push(file.path.id)
                    }
                }
            }

            
            spek[idx].filePDF = this.pdfNewValSpek

            this.input.spesifikasi = spek
           
            this.$bvModal.hide("modal-hapus-se-spek")
        },

    },

    watch:{

        //----------------- Pantau Jenis Barang -----------------

        'input.jenisBarang': function(id){
            if (this.jenisBarang.length != 0) {
                let jenis = this.jenisBarang.filter(item => item.id == id)
                let namaJenis = jenis[0].jenisPinjaman.name
                if (namaJenis == 'Kendaraan') {
                    this.isKendaraan = true
                } 
                else if(namaJenis == 'Elektronik') {
                    this.isKendaraan = false
                }
            }
        },

        "pdf.urlPDF.files" : function(newVal){
           
            //Hapus SE
            if(this.pdfRecords.length > newVal.length){
              
                this.pdf.urlPDF.files = this.pdfRecords
                this.pdfNewVal = newVal
                this.$bvModal.show("modal-hapus-se")
            }
            //Tambah SE
            else {
            let pdf = []
            let i = 0
            for(var file of this.pdf.urlPDF.files){
               
                let name = file.name
               
                pdf.push(file)
            }
          
            this.input.filePDF = pdf
            this.pdfRecords = pdf
           
            }
            
        },

        "pdf.file.fileList" : function(newVal){
          
            let Pdfbase64 = []
            let i = 0
            for(var file of this.pdf.file.fileList){
               
                let name =file.name
              
                Pdfbase64.push(file)
            }
           
            this.input.filePDF = Pdfbase64
        },

        "pdfKondisi.urlPDF.files" : function(newVal){
           
            //Hapus SE
            if(this.pdfRecordsKon.length > newVal.length){
               
                this.pdfKondisi.urlPDF.files = this.pdfRecordsKon
                this.pdfNewValKon = newVal
                this.$bvModal.show("modal-hapus-se-kon")
            }
            //Tambah SE
            else {
            let pdf = []
            let i = 0
            for(var file of this.pdfKondisi.urlPDF.files){
               
                let name = file.name
                pdf.push(file)
            }
            this.input.filePDFKondisi = pdf
            this.pdfRecordsKon = pdf
            }
            
        },

        "pdfKondisi.file.fileList" : function(newVal){
            let Pdfbase64 = []
            let i = 0
            for(var file of this.pdfKondisi.file.fileList){
                let name =file.name
                Pdfbase64.push(file)
            }
         
            this.input.filePDFKondisi = Pdfbase64
        },


    },


    created(){
        this.init()
    }
}
</script>
